module.exports = __webpack_public_path__ + "static/media/food-delivery.f4789262.png";